import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/configureStore";

declare global {
  interface Window {
    fcWidgetMessengerConfig?: {
      siteId: string;
    };
    fwcrm?: {
      on: (event: string, callback: () => void) => void;
    };
    fcWidget?: {
      init: (options: { siteId: string }) => void;
      setExternalId: (id: string) => void;
      user: {
        setFirstName: (name: string) => void;
        setEmail: (email: string) => void;
        setProperties: (properties: Record<string, string>) => void;
      };
    };
  }
}

if (typeof window !== "undefined") {
  window.fcWidgetMessengerConfig = {
    siteId: "MalaebWeb",
  };
}

const FreshchatWidget = () => {
  const userState = useSelector((state: RootState) => state?.malaeb?.user_data);
  const id = useSelector((state: RootState) => state?.malaeb?.user_uuid);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.fcWidgetMessengerConfig = {
        siteId: "MalaebWeb",
      };
    }

    const script = document.createElement("script");
    script.src = "//fw-cdn.com/15187220/6610214.js";
    script.setAttribute("widgetId", "74ea9a36-76a8-4f9b-a3f9-680467b8052b");
    script.setAttribute("chat", "true");
    script.async = true;

    script.onload = () => {
      if (typeof window !== "undefined" && window.fcWidget) {
        window.fcWidget.init({
          siteId: "MalaebWeb",
        });
      }
    };

    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  useEffect(() => {
    if (!userState || !id) return;

    const identifyUser = () => {
      if (typeof window !== "undefined" && window.fwcrm && window.fcWidget) {
        const { name, email, phone_number } = userState;
        const fcWidget = window.fcWidget;

        window.fwcrm.on("user:created", function () {
          const widget = window.fcWidget;
          if (!widget) return;

          widget.setExternalId(id || undefined);

          widget.user.setFirstName(name || undefined);

          widget.user.setEmail(email || undefined);

          const properties: Record<string, string> = {};
          properties.phone_number = phone_number || undefined;

          if (Object.keys(properties).length > 0) {
            widget.user.setProperties(properties);
          }
        });
      }
    };

    if (typeof window !== "undefined" && window.fwcrm && window.fcWidget) {
      identifyUser();
      return;
    }

    const checkFreshchat = setInterval(() => {
      if (typeof window !== "undefined" && window.fwcrm && window.fcWidget) {
        identifyUser();
        clearInterval(checkFreshchat);
      }
    }, 100);

    setTimeout(() => {
      clearInterval(checkFreshchat);
    }, 10000);

    return () => {
      clearInterval(checkFreshchat);
    };
  }, [userState, id]);

  return null;
};

export default FreshchatWidget;
